import * as yup from 'yup'

export const transferCrmSchema = yup.object().shape({
  number: yup
    .string()
    .transform((value) => (value || '').replace(/\s+/g, ''))
    .required('Informe o CRM')
    .matches(/^\d+$/, 'O CRM deve conter apenas números'),
  uf: yup.string().required('Selecione a UF')
})

export const createInviteSchema = yup.object().shape({
  crm: yup
    .string()
    .transform((value) => (value || '').replace(/\s+/g, ''))
    .required('Informe o CRM'),
  crmUf: yup.string().required('Selecione o CRMUF'),
  companyIds: yup
    .array()
    .min(1, 'Selecione ao menos uma empresa')
    .required('Selecione ao menos uma empresa')
})
